/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import React from 'react'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { useModalContext } from '@context/ModalContext/ModalContext'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import styles from './button.module.scss'

const NColumnGridCta = ({ data, segmentEventCommonProperties }) => {
  const { setShow } = useModalContext()

  const onButtonClick = () => {
    ;(async () => {
      const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      trackEvent('tap_btn_engage', {
        ...properties,
        funnel: 'engage',
      })
    })()

    if (data.link) {
      window.open(data.link, '_blank')
    } else {
      setShow(true)
    }
  }
  if (data && Object.keys(data).length !== 0) {
    const ctaContainerClassName = `${styles.cardCta} ${styles[data?.ctaType]}`

    return (
      <button
        className={ctaContainerClassName}
        type="button"
        onClick={() => {
          onButtonClick()
        }}>
        <span>{data.name}</span>
      </button>
    )
  }
  return null
}

export default NColumnGridCta
